<template>
  <ULabel :placeholder="placeholder" :filled="val?true:false" :error="error">
    <input autocomplete="off" ref="input" :type="type" class="ulabel__input" v-model="val" :name="name" :required="required">
  </ULabel>
</template>

<script>
import ULabel from './ULabel.vue'
import { MaskInput } from "maska"

export default {
  components: { ULabel },
  data: ()=>({
    changed: false
  }),
  props: {
    name: {type: String, required: true},
    modelValue: {type: String, default: ''},
    placeholder: {type: String},
    required: {type: Boolean},
    urlcheck: {type: Boolean, default: false},
    mask: {type: String},
    type: {type: String, default: 'text'},
    regex: {type: RegExp},
    tooltip: {type: String},
    focusstring: {type: String, default: ''}
  },
  methods: {
    isValidHttpUrl(string) {
      let url
      try {
        url = new URL(string)
        if (!url.hostname.match(/\.[^.]+/)) return false
      } catch (_) {
        return false
      }
      return url.protocol === "http:" || url.protocol === "https:"
    },
  },
  computed: {
    val:{
      get(){
        return this.modelValue
      },
      set(v){
        this.$emit('update:modelValue', v)
      }
    },
    error(){
      if (!this.changed) return ''
      if (this.regex && !(this.modelValue.match(this.regex))) return this.tooltip
      if (this.urlcheck && !this.isValidHttpUrl(this.modelValue)) return this.tooltip
      if (this.required && !this.modelValue) return 'заполните поле'
      this.$emit('correct')
      return ''
    }
  },
  mounted(){
    if (this.mask) 
      new MaskInput(this.$refs.input, { mask: this.mask })
    if (this.focusstring) {
      this.$refs.input.addEventListener('focus', ()=>{
        if (!this.val) this.val = this.focusstring
      })
      this.$refs.input.addEventListener('blur', ()=>{
        if (this.val == this.focusstring) this.$emit('update:modelValue', '')
      })
    }      
  },
  watch: {
    modelValue(v){
      if (v)
        this.changed = true
    },
    error(v){
      this.$emit('error',v)
    }
  }
}
</script>

<style lang="sass" scoped>

</style>